import { Message } from 'primereact/message';
import { Tooltip } from 'primereact/tooltip';
import { useLanguageContext } from '../../contexts/LanguageContext';

function FormInput({
  label,
  required,
  isValid,
  tooltipMessage,
  helpMessage,
  children,
  errorMessage,
  className,
  translatable
}) {
  const { currentLanguage } = useLanguageContext();
  return (
    <div className={`flex flex-col w-full ${className}`}>
      <div className="flex flex-row w-full justify-between items-center py-1">
        <div className="flex flex-row gap-x-3 items-center">
          <label>{label}</label>
          {translatable && <span className={`text-xs fi fi-${currentLanguage.code}`}></span>}
          {required && (
            <span
              data-pr-tooltip={tooltipMessage || 'Champs obligatoire'}
              className={`pi custom-tooltip-label cursor-pointer ${
                isValid ? 'pi-check-circle text-green-700' : 'pi-info-circle text-orange-500'
              }`}></span>
          )}
        </div>
        {helpMessage && (
          <small id="username-help" className="italic">
            {helpMessage}
          </small>
        )}
      </div>
      {children}

      <Tooltip target=".custom-tooltip-label" />
      {errorMessage && <Message className="mt-2 w-fit" severity="error" text={errorMessage} />}
    </div>
  );
}

export default FormInput;
